import { Component, computed, input } from '@angular/core';
import { MDTagComponent } from '@melodic-ui/components';
import { IndicatorType } from '@melodic-ui/types/indicator-type.type';

@Component({
	selector: 'lb-invoice-status-tag',
	templateUrl: './invoice-status-tag.component.html',
	styleUrls: ['./invoice-status-tag.component.scss'],
	imports: [MDTagComponent],
	standalone: true
})
export class InvoiceStatusTagComponent {
	invoiceStatus = input.required<string>();

	tagType = computed<IndicatorType>(() => {
		const status = this.invoiceStatus();
		switch (status.toLowerCase()) {
			case 'submitted':
				return 'success';
			case 'processed':
				return 'success';
			case 'flagged':
				return 'error';
			default:
				return 'tertiary';
		}
	});
}
